<ng-container *ngIf="oldConfirmScreen; else newConfirmScreen">
  <div class="single-card-column max-width-class">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon full-icon">
          <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
            <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
        </ng-container>
        <ng-template #acmicCloseIcon>
            <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
        </ng-template>
        </div>
        <div>
          <h1 class="title-copy">{{ "EPAY_ENROLL_TITLE" | translate }}</h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="font-size medium-font">
          {{ "EPAY_CONFIRM_ONE" | translate }}
        </p>
        <p class="font-size medium-font">
          {{ "EPAY_CONFIRM_TWO" | translate }}
          <strong>{{ "EPAY_CONFIRM_TWO_STRONG" | translate }}</strong>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col epay-enroll">
        <div class="epay-enroll-info">
        <p>
          <span class="font-color">{{ "ACCOUNT_HOLDER" | translate }}:</span>
          <strong>
            {{ billingInfo?.bankAccount?.accountHolderName | titlecase }}
          </strong>
        </p>
        <p>
          <span class="font-color">{{ "ROUTING/AB" | translate }}:</span>
          <strong> {{ billingInfo?.bankAccount?.routingNumber?.digits }} </strong>
        </p>
        <p>
          <span class="font-color">{{ "ACCOUNT_NUMBER" | translate }}:</span>
          <strong>
            {{
              billingInfo?.bankAccount?.accountNumber?.digits | maskAccountNumber
            }}
          </strong>
        </p>
        <p>
          <span class="font-color">{{ "TYPE_OF_ACCOUNT" | translate }}:</span>
          <strong> {{ accountType | titlecase }} </strong>
        </p>
        <p>
          <span class="font-color"
            >{{ "MONTHLY_DEDUCTION_DATE" | translate }}:</span
          >
          <strong> {{ billingInfo?.deductionDay }}</strong>
        </p>
    </div>
    </div>
    </div>
    <div class="row margin-vertical mv16 text-center">
      <div class="col">
        <mapfre-button
          [additionalClasses]="'basic primary large mx-auto waves-effect'"
          (click)="reSyncBilling()"
        >
          {{ "CONTINUE" | translate }}
        </mapfre-button>
      </div>
    </div>
  </div> 
</ng-container>

<ng-template #newConfirmScreen>
  <ng-container *ngIf="billedInvoice">    
    <app-imp-notice [theme]="'blue'" [impText]='importantText'></app-imp-notice>
    <app-attention-info [attentionText]="attentionText"></app-attention-info>
  </ng-container>

  <div class="confirm-width-container">
    <ng-container *ngIf="loading">
      <mapfre-loading></mapfre-loading>
    </ng-container>
    <ng-container *ngIf="!loading">
      <div class="text-center">
        <div class="modal-icon-box-center">        
          <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
            <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
          </ng-container>
          <ng-template #acmicCloseIcon>
              <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
          </ng-template>
        </div>
        <div class="autopay-title">
          Your {{ policyType }} policy {{ policyId }} is successfully enrolled in autopay
        </div>
        <ng-container *ngIf="!isLegacyPolicy; else legacyText">
          <div class="autopay-sub-title top-space">
            {{ "PROCESSING_CHANGES" | translate }}
            <p>{{ (policyId?.length === 6 ? "BILLING_SECTION_INVOICE" : "BILLING_SECTION_AUTOPAY_STATEMENT") | translate }}</p>            
          </div>
        </ng-container>
        <ng-template #legacyText>
          <div class="autopay-sub-title top-space" *ngIf="!isTWRecurringCCDC">
            {{ "EPAY_PROCESSING_15DAYS" | translate }}
          </div>
          <div class="autopay-sub-title top-space confirm-subtitle-width" *ngIf="isTWRecurringCCDC">
            {{ "BILLING_SECTION_INVOICE" | translate }}
          </div>
        </ng-template>
        <div class="autopay-sub-title top-space mt-3" *ngIf="billedInvoice && !isLegacyPolicy">
          Please note: <span class="fw-400">the estimated deduction may not include any increase or decrease in premiums due to the removal of discounts or policy changes.</span>
        </div>
      </div>  

      <div class="background-details-card" *ngIf="!isTWRecurringCCDC">
        <div class="block-flex-colm">
          <div class="details-data">
            <div class="label">{{ "TYPE_OF_ACCOUNT" | translate }}:</div>
            <div class="value">{{ accountType | titlecase}}</div>
          </div>

          <div class="details-data" *ngIf="company !== 'TW'">
            <div class="label">{{ "MONTHLY_DEDUCTION_DATE" | translate }}:</div>
            <div class="value">{{ billingInfo?.deductionDay }}</div>
          </div>

          <div class="details-data">
            <div class="label">{{ "BANK_ACCOUNT_HOLDER" | translate }}:</div>
            <div class="value">{{ billingInfo?.bankAccount?.accountHolderName | titlecase }}</div>
          </div>

          <div class="details-data" *ngIf="isLegacyPolicy && billingInfo?.bankAccount?.bankName">
            <div class="label">{{ "Bank name" | translate }}:</div>
            <div class="value">{{ billingInfo?.bankAccount?.bankName | titlecase }}</div>
          </div>

          <div class="details-data">
            <div class="label">{{ "ROUTING/AB" | translate }}:</div>
            <div class="value">{{ billingInfo?.bankAccount?.routingNumber?.digits | titlecase }}</div>
          </div>

          <div class="details-data">
            <div class="label">{{ "BANK_ACCOUNT_NUMBER" | translate }}:</div>
            <div class="value">{{ bankAccountNumber }}</div>
          </div>

          <ng-container *ngIf="company === 'TW' || company === 'ACIC'">
             <div class="details-data">
            <div class="label">{{ "Date" | translate }}:</div>
            <div class="value">{{ currDate }}</div>
          </div>

          <div class="details-data">
            <div class="label">{{ "Time" | translate }}:</div>
            <div class="value">{{ currTime }}</div>
          </div>
           </ng-container>
        </div>
      </div>
      <ng-container *ngIf="billedInvoice; else noBilled">
        <div class="add-info">
          {{"LIKE_TO_MAKE_PAYMENT" | translate }}
        </div>
      </ng-container>
      <ng-template #noBilled>
        <div class="add-info" *ngIf="plannedWithdrawalDate?.length">
          {{"FIRST_DEDUCTION" | translate }} {{plannedWithdrawalDate}}.
        </div>
      </ng-template>

      <ng-container *ngIf="billedInvoice; else noBilledAction">
        <div class="row margin-vertical mv24 text-center">
          <div class="col">
            <mapfre-button [additionalClasses]="'basic primary large pay-now mx-auto waves-effect'" (click)="payNow()">
              {{ "PAY_NOW" | translate }}
            </mapfre-button>
          </div>
        </div>
        <div class="text-center">
          <div class="col">
            <mapfre-button 
              (click)="navigateBack()"
              additionalClasses="link-button small-btn autopay-not-now"
              [backIcon]="backIcon"
              [iconClasses]="'align-middle'" 
              [showIconsCustom]="true">
              {{ "Not now" | translate }}
            </mapfre-button>
          </div>
        </div>
      </ng-container>
      <ng-template #noBilledAction>
        <div class="btn-sec w-100-mobile mt-4">
          <mapfre-button [additionalClasses]="'basic primary large waves-effect'" (click)="reSyncBilling()">
            {{ isLegacyPolicy && !isTWRecurringCCDC ? "Continue" : "Ok"| translate }}
          </mapfre-button>
        </div>
      </ng-template>
    </ng-container>
  </div>
</ng-template>